import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../../../components/ui/alert-dialog";
import { useLanguage } from "../../../contexts/LanguageContext";
import { apptLabels } from "../labels";

interface DeleteAppointmentDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export function DeleteAppointmentDialog({
  isOpen,
  onOpenChange,
  onConfirm,
}: DeleteAppointmentDialogProps) {
  const { lang } = useLanguage();
  const t = apptLabels[lang];

  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader className="text-left">
          <AlertDialogTitle>{t.editModal.deleteDialog.title}</AlertDialogTitle>
          <AlertDialogDescription>{t.editModal.deleteDialog.description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t.editModal.deleteDialog.cancel}</AlertDialogCancel>
          <AlertDialogAction className="bg-red-600 hover:bg-red-700" onClick={onConfirm}>
            {t.editModal.deleteDialog.delete}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
